/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, CanBeSignals, ContainerProps, $Container, $RichText} from '@gongxigames/framework/core/fragments/BuilderY';
import {Point, TextStyle} from 'pixi.js';

type TextSlidesProps = ContainerProps & CanBeSignals<{
    activeIndex: number;
    text: string;
    style: TextStyle;
    textPosition: Point;
}>;

export const $TextSlides: FC<TextSlidesProps> = (props) => {
    return <$Container {...props}>
        <$RichText anchor={0.5} position={props.textPosition ?? {x: 0, y: 0}} text={props.text} style={props.style} />
    </$Container>;
};